module.exports = __webpack_public_path__ + "static/media/USYG100084.b67e444a.jpg";